<hawk-record-navigation
  class="common_style"
  [breadcrumbLinkList]="[{ description: 'Projekte', link: '/a/projekt' }]"
  [root]="'project'"
  [leafDescription]="'Neues Projekt'"
  class="app-page"
>
  <div class="page-content page-frame">
    <form
      [formGroup]="projectForm"
      class="page-sheet max-w-4xl mx-auto grid grid-cols-2 grid-flow-dense"
      (submit)="onSubmit()"
    >
      <section class="bm-card bm-card-sm row-span-3">
        <fieldset class="bm-card-body bm-fieldset">
          <h2 class="bm-card-title">Stammdaten</h2>

          <label class="bm-fieldset-label">Name*</label>
          <input class="bm-input w-full" type="text" formControlName="name" />

          <label class="bm-fieldset-label">Beschreibung</label>
          <textarea class="bm-textarea w-full" formControlName="description"></textarea>

          <label class="bm-fieldset-label">Typ*</label>
          <div class="flex flex-row gap-2" aria-label="Select an option">
            <label class="bm-fieldset-label">
              <input type="radio" class="bm-radio" formControlName="type" value="MAINTENANCE" />Wartung
            </label>
            <label class="bm-fieldset-label">
              <input type="radio" class="bm-radio" formControlName="type" value="PROJECT_BUSINESS" />Projektgeschäft
            </label>
          </div>

          <label class="bm-fieldset-label">Kunde*</label>
          <select class="bm-select w-full" formControlName="customer_id">
            @for (customer of customers; track $index) {
              <option [value]="customer.id">{{ customer.name }}</option>
            }
          </select>

          <label class="bm-fieldset-label">Kostenstelle</label>
          <input class="bm-input w-full" type="text" formControlName="cost_center" />

          <label class="bm-fieldset-label">Cut off time</label>
          <input class="bm-input w-full" type="time" formControlName="cut_off_time" />
          <span>Ab diesem Zeitpunkt verlängert sich die SLA um einen Tag. Format: '15:00'</span>

          <label class="bm-fieldset-label">
            <input type="checkbox" class="bm-checkbox" formControlName="select_products" />Produktauswahl aktiviert
          </label>
        </fieldset>
      </section>
      <section class="bm-card bm-card-sm col-1">
        <fieldset class="bm-card-body bm-fieldset">
          <h2 class="bm-card-title">Kontakt</h2>

          <label class="bm-fieldset-label">Daten</label>
          <textarea class="bm-textarea w-full" formControlName="contact"></textarea>

          <label class="bm-fieldset-label">E-mail</label>
          <input class="bm-input w-full" formControlName="email" />
          <span>
            Mehrere E-Mails können mit einem Semikolon getrennt werden. Diese erhalten Nachrichten über Statusänderungen
          </span>
        </fieldset>
      </section>
      <section class="bm-card bm-card-sm">
        <fieldset class="bm-card-body bm-fieldset">
          <h2 class="bm-card-title">Zeitraum</h2>
          <label class="bm-fieldset-label"> Start </label>
          <div class="bm-join w-full">
            <input class="bm-input bm-join-item w-full" [matDatepicker]="picker_start" formControlName="start" />
            <mat-datepicker #picker_start />
            <button
              class="bm-btn bm-join-item"
              (click)="picker_start.opened ? picker_start.close() : picker_start.open(); (false)"
            >
              <span class="fa fa-calendar"></span>
            </button>
          </div>

          <label class="bm-fieldset-label"> Ende </label>
          <div class="bm-join w-full">
            <input
              class="bm-input bm-join-item w-full"
              [matDatepicker]="picker_end"
              formControlName="end"
              (click)="picker_end.open()"
            />
            <mat-datepicker #picker_end />
            <button
              class="bm-btn bm-join-item"
              (click)="picker_end.opened ? picker_end.close() : picker_end.open(); (false)"
            >
              <span class="fa fa-calendar"></span>
            </button>
          </div>
        </fieldset>
      </section>
      <section class="bm-card bm-card-sm">
        <fieldset class="bm-card-body bm-fieldset">
          <h2 class="bm-card-title">
            Mailbenachrichtigungen
            <fa-icon
              style="cursor: help"
              [icon]="faInfoCircle"
              data-tip="Alle Techniker eines Einsatzes erhalten bei folgenden Ereignissen eine E-Mail"
              class="bm-tooltip"
            />
          </h2>
          <label class="bm-fieldset-label">
            <input type="checkbox" class="bm-checkbox" formControlName="send_operation_new" />
            Einsatz wurde neu erstellt
          </label>
          <label class="bm-fieldset-label">
            <input type="checkbox" class="bm-checkbox" formControlName="send_operation_update" />
            Einsatz wurde geändert
          </label>
          <label class="bm-fieldset-label">
            <input type="checkbox" class="bm-checkbox" formControlName="send_operation_delete" />
            Einsatz wurde gelöscht (Storno)
          </label>
        </fieldset>
      </section>
      <section class="bm-card bm-card-sm">
        <fieldset class="bm-card-body bm-fieldset">
          <h2 class="bm-card-title">Dokumentation</h2>
          <label class="bm-fieldset-label">URL</label>
          <textarea class="bm-textarea w-full" formControlName="additional_documentation"></textarea>
        </fieldset>
      </section>
      <div class="flex flex-row items-center justify-end gap-2 col-span-2">
        <a class="bm-btn bm-btn-ghost" href="/a/projekt"> Abbrechen </a>
        <button class="bm-btn bm-btn-primary" [disabled]="!projectForm.valid">Projekt erstellen</button>
      </div>
    </form>
  </div>
</hawk-record-navigation>
